export default String.raw`
{% assign type = include -%}

{% if type == 'orderDa' -%}
    {% if deliveryAddress -%}
        {% assign address = deliveryAddress -%}
    {% else -%}
        {% assign address = cart.Customer.DeliveryAddress -%}
    {% endif -%}
{% elseif type == 'inv-add' -%}
    {% if invoiceAddress -%}
        {% assign address = invoiceAddress -%}
    {% else -%}
        {% assign address = cart.Customer.InvoiceAddress -%}
    {% endif -%}
    {% assign companyCheck = false -%}
    {% if usr.Authenticated == false and settings.defaultRegistration == 'company' -%}
        {% assign companyCheck = true -%}
        {% if page.Cookies.notAuthUserType == 'private' -%}
            {% assign companyCheck = false -%}
        {% endif -%}
    {% endif -%}
{% elseif type == 'buyerAddress' -%}
    {% if buyerAddress -%}
        {% assign address = buyerAddress -%}
    {% else -%}
        {% assign address = cart.Customer.Buyer -%}
    {% endif -%}
{% endif -%}

<div class="cart-address-presentation">
    {% if type == 'inv-add' -%}
        <div class="cart-address-presentation__text">
            <div>{{ translations.BuyInShopAs }}:</div>
            <div>
                {% if cart.Customer.Company or companyCheck -%}
                    {{ translations.Company }}
                {% else -%}
                    {{ translations.PrivatePerson }}
                {% endif -%}
            </div>
        </div>

        <div class="cart-address-presentation__text">
            <div>{{ translations.SalesDocument }}:</div>
            <div>
                {% if cart.Customer.Invoice or companyCheck -%}
                    {{ translations.Invoice }}
                {% else -%}
                    {{ translations.Recipe }}
                {% endif -%}
            </div>
        </div>
    {% endif -%}

    {% unless type == 'inv-add' -%}
        <div class="cart-address-presentation__text">
            <div>{{ translations.Email }}:</div>
            <div>{{ cart.Customer.Email }}</div>
        </div>
    {% endunless -%}

    {% unless type == 'inv-add' and cart.Customer.Invoice == false -%}
        <div class="cart-address-presentation__text">
            <div>{{ translations.Country }}:</div>
            <div>{{ config.Countries[address.Country].Name }}</div>
        </div>
    {% endunless -%}

    {% if type == 'inv-add' and cart.Customer.TIN != '' -%}
        {% unless cart.Customer.Company == false and cart.Customer.Invoice == false -%}
            <div class="cart-address-presentation__text">
                <div>{{ translations.TIN }}:</div>
                <div>
                    {% if config.ENTERPRISE and cart.Customer.VATEU != '' -%}
                        {{cart.Customer.VATEU}}
                    {% endif -%}

                    {{cart.Customer.TIN}}
                </div>
            </div>
        {% endunless -%}
    {% endif -%}

    {% unless type == 'inv-add' and cart.Customer.Invoice == false -%}
        <div class="cart-address-presentation__text">
            <div>
                {% if cart.Customer.Company == false -%}
                    {{ translations.NameAndSurname }}:
                {% else -%}
                    {{ translations.CompanyName }}:
                {% endif -%}
            </div>
            <div>
                {{address.Name}} {{address.Name2}}
            </div>
        </div>
        
        <div class="cart-address-presentation__text">
            <div>
                {{ translations.Street }}:
            </div>
            <div>
                {{address.Street}}
                {{address.StreetNo}}{% if address.UnitNo != ''-%}/{{address.UnitNo}}{% endif -%}
            </div>
        </div>
        <div class="cart-address-presentation__text">
            <div>
                {{ translations.City }}:
            </div>
            <div>
                {{address.ZipCode}} {{address.City}}
            </div>
        </div>
    {% endunless -%}

    {% if address.PhoneNo != '' -%}
        <div class="cart-address-presentation__text">
            <div>{{ translations.PhoneNumber }}:</div>
            <div class="phoneNumberContainer">{{ address.PhoneNo }}</div>
        </div>
    {% endif -%}

    {% if type == 'orderDa' or type == 'buyerAddress' -%}
        <div class="form-js">
            <input type="hidden" name="zipCode" value="{{address.ZipCode}}" {% if cart.SelectedDelivery.CollectionPointTypeId == 2 -%} class="show-map-js" {% endif -%} >
        </div>
    {% endif %}
</div>
`